import AxiosService from './AxiosService'
import { Credentials } from '../Authentication/AuthTypes'

class LoginRestService {
  updatePassword(data: any): Promise<any> {
    return AxiosService.put('/auth/changePassword', data)
  }
  autoLogin(): Promise<any> {
    return AxiosService.post('/auth/auto')
  }

  login(credentials: Credentials): Promise<any> {
    return AxiosService.post('/auth/login', credentials)
  }

  getPermissions(): Promise<any> {
    return AxiosService.get('/auth/permissions')
  }
}

export default new LoginRestService()
